import logger from './logger';
import thunk from 'redux-thunk';
import { getCookie } from '../utils/cookie';
import hydrateDummy, { shouldHydrate } from '@AIZ-GL/hydrate-dummy';
import { createTracker } from 'redux-segment';
import './segment';

const shouldHydrateDummy =
  process.env.NODE_ENV !== 'production' && shouldHydrate();

const noMixpanelTracking =
  process.env.NODE_ENV !== 'production' || getCookie('no_track', document);

const middlewares = [thunk];

if (process.env.REACT_APP_ENABLE_LOGGING === 'true') {
  middlewares.push(logger);
}

if (
  !noMixpanelTracking &&
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_ENABLE_TRACKING
) {
  const tracker = createTracker();

  middlewares.push(tracker);
}

if (shouldHydrateDummy) {
  middlewares.push(hydrateDummy);
}

export default middlewares;
